var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vxe-grid',{attrs:{"max-height":"500","data":_vm.table.data,"columns":_vm.table.columns,"cell-style":_vm.cellStyle,"loading":_vm.tableLoading}})
}
var staticRenderFns = []

export { render, staticRenderFns }